import { render, staticRenderFns } from "./CharacterRoom.vue?vue&type=template&id=2802c15c&scoped=true&"
import script from "./CharacterRoom.vue?vue&type=script&lang=ts&"
export * from "./CharacterRoom.vue?vue&type=script&lang=ts&"
import style0 from "./CharacterRoom.vue?vue&type=style&index=0&id=2802c15c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2802c15c",
  null
  
)

export default component.exports